import { composeInitialState } from '@opengov/compose-app';
import { fromJS } from 'immutable';

import { composeStateMachine } from '../../module';
import { Locale, Namespace } from '../records';

export const localeInitialState = composeInitialState({
  currentLocale: Locale()
});

export const localeState = composeStateMachine('locale', localeInitialState, (compose) => ({
  setCurrentLocale: compose.action((state, localeId: string) =>
    state.update('currentLocale', (locale) => locale.set('locale', localeId))
  ),

  loadingLocale: compose.payloadlessAction((state) =>
    state.update('currentLocale', (locale) =>
      locale.set('namespaces', locale.namespaces.map((ns) => ns.set('loading', true)).toMap())
    )
  ),

  loadingLocaleNamespace: compose.action((state, namespace: string) =>
    state.update('currentLocale', (locale) =>
      locale.set(
        'namespaces',
        locale.namespaces.set(
          namespace,
          locale.namespaces.has(namespace)
            ? locale.namespaces.get(namespace).set('loading', true)
            : Namespace({ loading: true })
        )
      )
    )
  ),

  loadedLocaleNamespace: compose.action((state, payload: { namespace: string; data: any }) =>
    state.update('currentLocale', (currentLocale) =>
      currentLocale.set(
        'namespaces',
        currentLocale.namespaces.set(payload.namespace, Namespace({ loading: false, data: fromJS(payload.data) }))
      )
    )
  ),

  loadLocaleNamespaceFailure: compose.action((state, payload: { namespace: string; error: any }) =>
    state.update('currentLocale', (locale) =>
      locale.set(
        'namespaces',
        locale.namespaces.set(
          payload.namespace,
          locale.namespaces.has(payload.namespace)
            ? locale.namespaces.get(payload.namespace).set('loading', false).set('error', payload.error)
            : Namespace({ loading: false, error: payload.error })
        )
      )
    )
  )
}));

export const {
  actions: localeActions,
  actionCreators: localeActionCreators,
  reducer: localeReducer,
  selector: localeSelector
} = localeState;
